/**
 * Tutorial guidato delle Categorie in evidenza.
 *
 * Unico preparativo: il menu a tre puntini della riga, aperto e richiuso dal giro.
 * L'interruttore il tutorial non lo tocca, perche' scrive subito sul sito pubblico.
 */
import { rowMenuTour } from './tour-menu';

const SCOPE = '[data-tour-scope="highlighted-categories"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

const menu = rowMenuTour('highlighted-categories');

/** Rimette la pagina com'era: menu della riga chiuso. */
export function stopHighlightedCategoriesTour() {
	return menu.closeMenus();
}

export function createHighlightedCategoriesTourSteps() {
	return [
		{
			body: "Da qui scegli quali categorie il sito pubblico mette nel menu principale. Non e' una categoria nuova ne' un ordinamento del catalogo: e' solo la vetrina in cima alle pagine.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Categorie in evidenza',
		},
		{
			before: menu.closeMenus,
			body: "La ricerca filtra per nome della categoria e parte da tre caratteri in su: con meno di tre torna l'elenco completo. Premi Invio o la lente per applicarla.",
			key: 'search',
			placement: 'bottom',
			target: at('search'),
			title: 'Cercare una categoria',
		},
		{
			body: "Il menu a tendina restringe l'elenco a una sola categoria scelta dall'albero. La X lo azzera e rimette tutte le categorie. Ricerca, filtro e pagina restano nell'indirizzo: ricaricando o tornando qui li ritrovi.",
			key: 'filter',
			placement: 'bottom',
			target: at('filter'),
			title: 'Filtrare per categoria',
		},
		{
			body: "La tabella mostra lo stato in evidenza, la data di creazione, l'id della categoria, il nome nella lingua predefinita e quanti prodotti vi fanno riferimento.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: "L'interruttore mette la categoria in evidenza e salva subito, senza conferma: appena lo tocchi il sito se ne accorge. Tienine accese poche: il menu del sito ne mostra al massimo tre, le altre restano in evidenza senza comparire.",
			key: 'switch',
			placement: 'right',
			target: at('switch'),
			title: 'Mettere in evidenza',
		},
		{
			body: "I tre puntini a inizio riga aprono Modifica categoria: porta alla pagina della categoria (nome, testi, immagini), e Annulla o Salva riportano qui con la lista com'era.",
			before: menu.openRowMenu,
			key: 'row-menu',
			placement: 'right',
			target: menu.probe,
			timeout: 250,
			title: 'Il menu della riga',
		},
		{
			before: menu.closeMenus,
			body: "L'elenco arriva una pagina per volta dal server: da qui cambi pagina e quante righe vedere. Le categorie gia' in evidenza non salgono in cima, quindi per ritrovarle conviene la ricerca.",
			key: 'pagination',
			placement: 'top',
			target: `${SCOPE} .v-data-footer`,
			timeout: 400,
			title: "Sfogliare l'elenco",
		},
	];
}
